import { SummerAppFieldsValidators } from 'app/shared/enums/fields-validators.enum';
import { DialogService } from './../shared/services/dialog-service';
import { SchoolsAutocompleteModel } from './../shared/models/schools-autocomplete.model';
import { ToastsManager } from 'ng2-toastr';
import { QuestionBaseModel } from './../shared/models/question-base.model';
import { QuestionFieldSaveModel } from './../shared/models/question-save-model';
import { SaveStageModel } from './stage-save.model';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { SelectListItemModel } from './../shared/models/select-list-item.model';
import { Observable } from 'rxjs/Observable';
import { StageRowModel } from './stage/stage-row.model';
import { HttpClient } from '@angular/common/http';
import { DropdownQuestionModel } from './../shared/models/dropdown-question.model';
import { SummerAppFieldTypesEnum } from '../shared/enums/field-types.enum';
import { StageQuestionsService } from './stage-questions.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatIconRegistry, MatStep, MatStepper, MatSnackBar, MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material';
import { SafeResourceUrl } from '@angular/platform-browser';
import 'rxjs/add/observable/forkJoin';
import { SecurityService } from 'app/security/security.service';
import { Router } from '@angular/router';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';

export const customTooltipDefaults: MatTooltipDefaultOptions = {
      showDelay: 1000,
      hideDelay: 10,
      touchendHideDelay: 10,
}

@Component({
      selector: 'online-app-stages',
      templateUrl: './stages.component.html',
      styleUrls: ['./stages.component.scss'],
      providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipDefaults }],
})
export class StagesComponent implements OnInit {

      @ViewChild('stepper') stagesStepper: MatStepper;

      protected get isSummaryStepSelected() {
            return this.stages.length && this.stagesStepper.selectedIndex == this.stages.length;
      }

      protected stepperSelectedStep: number = this.secService.currentUserInfo.currentStageNumber - 1;

      protected providerAccess: boolean = sessionStorage.getItem('isProviderAccess') != null &&  sessionStorage.getItem('isProviderAccess') == 'true';

      protected hasDocumentRequested: boolean = this.secService.currentUserInfo.documentRequested? this.secService.currentUserInfo.documentRequested :
            false;

      private questions: QuestionBaseModel<any>[];

      protected stages: SelectListItemModel[] = [];

      protected stagesForms: FormGroup[] = [];
      protected stagesQuestions: any[] = [];

      protected summaryStageForm: FormGroup = new FormGroup({});

      protected showSummaryStage: boolean = false;

      constructor(private toastr: ToastsManager, private cd: ChangeDetectorRef,
            private dialogService: DialogService,
            private snackbar: MatSnackBar,
            private fb: FormBuilder, private loader: LoadingSpinnerService,
            private secService: SecurityService,
            private _stagesService: StageQuestionsService,
            private httpClient: HttpClient,
            private router: Router,
            private programsService: EnrollmentProgramsService, ) {
            this.loader.showSpinner();
            Observable.forkJoin(
                  this._stagesService.getStagesQuestions(),
                  this._stagesService.getStagesLookup()
            ).subscribe(data => {
                  this.questions = data[0];
                  this.stages = data[1];
                  this.stages.forEach(stage => {
                        const stageQuestions = this.questions.filter(i => { return i.stageLuid == parseInt(stage.value) });
                        this.stagesQuestions.push(stageQuestions);
                        const stageForm = this._stagesService.toFormGroup(stageQuestions);
                        this.stagesForms.push(stageForm);
                        let schoolAutocomplete = stageQuestions.find(i => i.fieldTypeName == SummerAppFieldTypesEnum.SchoolsAutoComplete);
                        if (schoolAutocomplete) {
                              (<SchoolsAutocompleteModel>schoolAutocomplete).setControlRef(<FormControl>stageForm.get(schoolAutocomplete.fieldName));
                              (<SchoolsAutocompleteModel>schoolAutocomplete).loadSchoolOptions(this._stagesService);
                        }
                        this.summaryStageForm.addControl(stage.value, stageForm);
                  });
                  
                  this.showSummaryStage = true;
                  this.loader.hideSpinner();
            });
      }

      ngOnInit() {
            let _disableStagePristineCheck = false;
            this.stagesStepper.selectionChange.subscribe((e) => {
                  if (_disableStagePristineCheck) {
                        _disableStagePristineCheck = false;
                        return;
                  }
                  const form = this.stagesForms[e.previouslySelectedIndex];
                  if (form && !form.pristine) {
                        this.dialogService.openDialog('Warning', `To proceed, please click the 'SAVE & CONTINUE' button.`);
                        _disableStagePristineCheck = true;
                        setTimeout(() => {
                              e.previouslySelectedStep.select();
                        });
                  }
            });
      }

      getStageIndex(stage) {
            return this.stages.indexOf(stage);
      }

      getSummaryStageNumber() {
            return this.stages.length + 1;
      }

      isCurrentStageUnsaved() {
            const index = this.stagesStepper.selectedIndex;
            const currentForm = this.stagesForms[index];
            return currentForm && !currentForm.pristine;
      }

      protected saveStage() {
            let index = this.stagesStepper.selectedIndex,
                  currentForm = this.stagesForms[index],
                  stage = this.stages[index],
                  currentStageQuestions = this.stagesQuestions[index],
                  referralCodeField = currentStageQuestions.find(i => { return i.validatorName == SummerAppFieldsValidators.RefferalCode }),
                  resumeField = currentStageQuestions.find(i => { return i.fieldTypeName == SummerAppFieldTypesEnum.ResumeUpload }),
                  doc = resumeField ? resumeField.file : null,
                  //docRequested = this.secService.currentUserInfo.documentRequested,
                  //Will need to extract the DOB, gender and contract code
                  //After, will need to make sure referencing the correct stage i.e the first stage
                  //Next will compare between the new info and the old info
                  callback = () => {
                        if (currentForm.invalid) {
                              this.stagesStepper.next();
                              this.dialogService.openDialog('Warning!', "There are invalid fields.");
                              return;
                        }
                        let model = new SaveStageModel(
                              currentStageQuestions.map((i: QuestionBaseModel<any>) => {
                                    let value = currentForm.get(i.fieldName).value;
                                    let date: Date;
                                    if (i.fieldTypeName == SummerAppFieldTypesEnum.Date) {
                                          date = new Date(value);
                                          date.setTime(date.getTime() - date.getTimezoneOffset() * 60000);
                                    }
                                    return new QuestionFieldSaveModel(i.onlineEnrollmentConfigurationId, i.fieldName, date ? date : value);
                              }),
                              parseInt(stage.value)
                        )
                        this._stagesService.saveStage(model, doc).subscribe((res) => {
                              if (res) {
                                    this.snackbar.open(`'${stage.name}' saved successfully.`, "Success", {
                                          duration: 2000,
                                          verticalPosition: 'top'
                                    });
                                    currentForm.markAsPristine();
                                    this.stagesStepper.next();
                                    this.secService.moveUserToNextStage();
                                    // if(docRequested){

                                    // }
                                    //After moving applicant to next stage will need to check 
                              }
                        });
                  }
            this.checkRefferalAndSubmit(referralCodeField, currentForm, callback);
      }

      private checkRefferalAndSubmit(referralCodeField, currentForm, callback) {
            if (referralCodeField) {
                  let referralCodeControl = currentForm.get(referralCodeField.fieldName);
                  this._stagesService.checkReferralCode(referralCodeControl.value).subscribe(res => {
                        if (!res)
                              referralCodeControl.setErrors({ wrongReferral: true })
                        callback();
                  })
            } else {
                  callback();
            }
      }

      protected complete() {
            this._stagesService.submitApplication().subscribe(() => {
                  this.programsService.getSubmissionMessage().subscribe(msg =>{
                        this.dialogService.openDialog(`Congratulations!`, msg != null ? msg : 'You have successfully compeleted your online application.')
                  });
                  this.router.navigate(['/thankyou']).then((e) => {
                        if (e) {
                              this.secService.logout().subscribe();
                        }
                  });
            });
      }

      protected showHelp() {
            let index = this.stagesStepper.selectedIndex,
                  stage = this.stages[index],
                  currentStageQuestions = this.stagesQuestions[index],
                  helpText = currentStageQuestions.map(it => {
                        if (it.helpText != null) {
                              return `<span class="font-weight-bold">${it.label}</span>
                              &nbsp;\u2014&nbsp;
                              <span>${it.helpText}</span> <br/>`
                        }
                        else
                              return;
                  }).join('\n');
            this.dialogService.openDialog(`Help & Hints`, helpText);
      }

      protected printPage() {
            window.print();
      }
      public get OpportunityStatement(): Observable<string> {
            return this.programsService.getOpportunityStatement();
      }
}





// WEBPACK FOOTER //
// ./src/app/stages/stages.component.ts